import { Link } from "react-router-dom";

const DesktopNavLinks = () => {
  return (
    <div className="hidden md:flex items-center gap-8 ml-auto mr-6">
      <Link to="/why-spharaka" className="text-sm font-medium hover:text-[#8932c8] transition-colors">
        Why Spharaka?
      </Link>
      <div className="relative group">
        <button className="flex items-center text-sm font-medium hover:text-[#8932c8] transition-colors">
          Products
        </button>
        <div className="absolute left-0 top-full w-48 invisible group-hover:visible bg-white shadow-lg rounded-md overflow-hidden border border-slate-200 opacity-0 group-hover:opacity-100 transition-all duration-300 z-50">
          <div className="py-1">
            <Link to="/products" className="block px-4 py-2 text-sm hover:bg-slate-50 font-medium">
              All Products
            </Link>
            <Link to="/products/spharakaxdr" className="block px-4 py-2 text-sm hover:bg-slate-50">
              Spharaka XDR
            </Link>
            <Link to="/products/auraxp" className="block px-4 py-2 text-sm hover:bg-slate-50">
              AuraXP
            </Link>
            <Link to="/products/ishwar" className="block px-4 py-2 text-sm hover:bg-slate-50">
              ISHWAR
            </Link>
          </div>
        </div>
      </div>
      <div className="relative group">
        <button className="flex items-center text-sm font-medium hover:text-[#8932c8] transition-colors">
          Solutions
        </button>
        <div className="absolute left-0 top-full w-48 invisible group-hover:visible bg-white shadow-lg rounded-md overflow-hidden border border-slate-200 opacity-0 group-hover:opacity-100 transition-all duration-300 z-50">
          <div className="py-1">
            <Link to="/solutions/enterprise" className="block px-4 py-2 text-sm hover:bg-slate-50">
              Enterprise
            </Link>
            <Link to="/solutions/smb" className="block px-4 py-2 text-sm hover:bg-slate-50">
              SMB
            </Link>
            <Link to="/solutions/government" className="block px-4 py-2 text-sm hover:bg-slate-50">
              Government
            </Link>
          </div>
        </div>
      </div>
      <div className="relative group">
        <button className="flex items-center text-sm font-medium hover:text-[#8932c8] transition-colors">
          Partners
        </button>
        <div className="absolute left-0 top-full w-48 invisible group-hover:visible bg-white shadow-lg rounded-md overflow-hidden border border-slate-200 opacity-0 group-hover:opacity-100 transition-all duration-300 z-50">
          <div className="py-1">
            <Link to="/partners/mssp" className="block px-4 py-2 text-sm hover:bg-slate-50">
              MSSP Partners
            </Link>
            <Link to="/partners/reseller" className="block px-4 py-2 text-sm hover:bg-slate-50">
              Reseller Partners
            </Link>
            <Link to="/partners/technology" className="block px-4 py-2 text-sm hover:bg-slate-50">
              Technology Partners
            </Link>
          </div>
        </div>
      </div>
      <Link to="/blogs" className="text-sm font-medium hover:text-[#8932c8] transition-colors">
        Insights
      </Link>
      <Link to="/about" className="text-sm font-medium hover:text-[#8932c8] transition-colors">
        About Us
      </Link>
    </div>
  );
};

export default DesktopNavLinks;
